<template>
  <EventsDayWidget />
</template>

<script>
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'

// EventsDayWidgetServer is the active implementation of the events-by-day widget.
const EventsDayWidget = () => ({
  component: import('@/components/center_widgets/EventsDayWidgetServer'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'EventsDayPage',
  components: { EventsDayWidget },
}
</script>
